import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-frequency',
  templateUrl: './review-frequency.component.html',
  styleUrls: ['./review-frequency.component.scss']
})
export class ReviewFrequencyComponent implements OnInit {
  loading = false;
  @Input() avgReviewFrequencyApiResponse = null;
  constructor() { }

  ngOnInit(): void {
  }

}
